// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './utils/store.js'
import router from './utils/router.js'
import ElementUI from 'element-ui'
import phocusUtiljs from 'phocus-js'
import * as http from './utils/http.js'
import * as filter from './utils/filter.js'
import * as common from './utils/common.js'
import VueObserveVisibility from 'vue-observe-visibility'
import 'vue-code-highlight/themes/prism-okaidia.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueAnime from 'vue-animejs'
import 'mango-css'
require('./utils/compos.js')

Vue.use(VueAnime)
Vue.use(ElementUI)
Vue.use(VueObserveVisibility)
Vue.config.productionTip = false
Vue.prototype.$ = phocusUtiljs

/* 注册HTTP方法 */
Object.keys(http).forEach(key => {
  Vue.prototype[key] = http[key]
})

/* 注册自定义方法 */
Object.keys(common).forEach(key => {
  Vue.prototype[key] = common[key]
})

/* 注册自定义方法 */
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    let that = this
    this.setWindowSize()
    this.readConfig()
    window.onresize = function () {
      that.setWindowSize()
    }
    window.addEventListener('scroll', this.handleScroll)
    this.$store.commit('updateRefresh', true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    /*
    * 查询config项
    */
    readConfig () {
      this.get({
        url: 'webConfigsRead',
        data: {
          con_team_id: '6',
          page_size: 100,
          page_num: 1
        }
      }, (r) => {
        if (r.code) {
          r.data.items.map(item => {
            if (item.con_key === 'nav_posts') {
              // 热门文章
              this.$store.commit('updateHotPosts', item.con_value)
            } else if (item.con_key === 'nav_works') {
              // 热门作品
              this.$store.commit('updateHotWorks', item.con_value)
            } else if (item.con_key === 'nav_sloganInfo') {
              // 公司标语
              this.$store.commit('updateSloganInfo', item.con_value)
            } else if (item.con_key === 'nav_serviceInfo') {
              // 服务信息
              this.$store.commit('updateServiceInfo', item.con_value)
            } else if (item.con_key === 'nav_contactInfo') {
              // 地图和联系信息
              this.$store.commit('updateContactInfo', item.con_value)
            } else if (item.con_key === 'nav_businessCope') {
              // 业务范围
              this.$store.commit('updateBusinessCope', item.con_value)
            } else if (item.con_key === 'nav_router') {
              // 路由配置
              this.$store.commit('updateRouter', item.con_value)
            } else if (item.con_key === 'nav_textInfo') {
              // 首页文字配置
              this.$store.commit('updateTextInfo', item.con_value)
            }
          })
        }
      })
    },
    /**
     * 窗口大小变化
     */
    setWindowSize () {
      let windowData = {
        w: this.size('innerWidth'),
        h: this.size('innerHeight')
      }
      this.$store.commit('windowResize', windowData)
    },
    /**
     * 滑动事件
     */
    handleScroll () {
      let data = document.documentElement.scrollTop || document.body.scrollTop
      this.$store.commit('scrollToTop', data)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js